import React from 'react';
import { IconButton } from '@material-ui/core';
import { ReactComponent as FilterIcon } from '../../assets/ICONS/filterIcon.svg';
import './costAnalysis.css';
import FilterGroupButtons from './FilterGroupButtons';

interface CostAnalysisHeaderProps {
  title: string;
  onOpenFilters: () => void;
  filterCategories: Array<{ id: string; label: string }>;
  selectedCategory: string;
  onCategoryChange: (categoryId: string, categoryLabel: string) => void;
}

const CostAnalysisHeader: React.FC<CostAnalysisHeaderProps> = ({
  title,
  onOpenFilters,
  filterCategories,
  selectedCategory,
  onCategoryChange,
}) => {
  return (
    <div className="costAnalysisHeader">
      <div className="headerLeftSection">
        <div className="costAnalysisHeaderTitle">{title}:</div>

        <FilterGroupButtons
          filterCategories={filterCategories}
          selectedCategory={selectedCategory}
          onCategoryChange={onCategoryChange}
        />
      </div>
      <div className="headerRightSection">
        <IconButton
          className="filterButton"
          onClick={onOpenFilters}
          aria-label="Filter"
        >
          <FilterIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default CostAnalysisHeader;
